import { ExportReportFormat } from "../../slices/reports/Types";

export const reportsSagaActionTypes = {
  callGetPartnersReportsSaga: "callGetPartnersReportsSaga",
  callSaveReportFormatSaga: "callSaveReportFormatSaga",
  callGetReportFormatsListSaga: "callGetReportFormatsListSaga",
  callDeleteReportFormatSaga: "callDeleteReportFormatSaga",
};

export type getPartnersReportsSagaActionPayloadType = {
  partner_status: string;
  partner_name: string;
  partner_type: string;
  partner_tier: string;
  partner_vertical: string;
  revenue_stream: string;
  account_manager: string;
  region: string;
  country: string;
  contract_name: string;
  contract_status: string;
  support_level?: string;
  start_date_range: string[];
  end_date_range: string[];
  saved_export_format: string;
  selected_options: ExportReportFormat;
};
export const getPartnersReportsSagaAction: (
  payload: getPartnersReportsSagaActionPayloadType
) => {
  type: string;
  payload: getPartnersReportsSagaActionPayloadType;
} = (payload) => {
  return {
    type: reportsSagaActionTypes.callGetPartnersReportsSaga,
    payload: payload,
  };
};

export const saveReportFormatSagaAction: (data: {
  payload: {
    saved_export_format: string;
    selected_options: ExportReportFormat;
  };
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  type: string;
  data: {
    payload: {
      saved_export_format: string;
      selected_options: ExportReportFormat;
    };
    setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  };
} = (data) => {
  return {
    type: reportsSagaActionTypes.callSaveReportFormatSaga,
    data: data,
  };
};

export const getReportFormatsListSagaAction: () => { type: string } = () => {
  return {
    type: reportsSagaActionTypes.callGetReportFormatsListSaga,
  };
};

export const deleteReportFormatSagaAction: (payload: {
  id: number;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  type: string;
  payload: {
    id: number;
    setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  };
} = (payload) => {
  return {
    type: reportsSagaActionTypes.callDeleteReportFormatSaga,
    payload: payload,
  };
};
